module.exports = __webpack_public_path__ + "static/media/logo_heart.51262090.svg";